import { env } from '@/env.mjs';

export const EXHAUSTED_DISCOUNT_CODES = `${env.NEXT_PUBLIC_ORDER_API_URL}/v3/promo-codes/exhausted-discount-codes`;
export const DISCOUNT_CODE = `${env.NEXT_PUBLIC_ORDER_API_URL}/v3/promo-codes/discount-code/`;
export const CUSTOMER_REFERRALS = `${env.NEXT_PUBLIC_ORDER_API_URL}/v3/promo-codes/customer-referrals/`;
